<template>
  <v-container class="text-center pa-0 ma-0 mt-1">
    <div class="body-2 font-weight-medium">
      {{ item.createdAt | dateFull}}
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'DateItemTimeline',

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
